import { cmsQueryKeys } from '@/services/cms/cmsQueryKeys';
import { getBlogRelatedArticles } from '@/services/cms/getBlogRelatedArticles';
import { useQuery } from '@tanstack/react-query';
import { BlogDetailedCarousel } from '../blog-detailed-carousel';
import { FullScreenLoadingSpinner } from '@/components/full-screen-loading-spinner';

interface RelatedArticlesProps {
  slug: string;
  category: string;
}
export const RelatedArticles = ({ slug, category }: RelatedArticlesProps) => {
  const { isPending, data, isError } = useQuery({
    queryFn: getBlogRelatedArticles,
    queryKey: [cmsQueryKeys.getBlogRelatedArticles, slug, category],
    staleTime: Infinity,
  });

  if (isPending) {
    return <FullScreenLoadingSpinner />;
  }
  if (isError) {
    return <h1>Error</h1>;
  }

  // Hide the section if it is less than 3 items
  if (data.length <= 2) {
    return null;
  }

  return (
    <div className="bg-warp-green-50">
      <div>
        <h3 className="font-nunito700 text-black text-xl md:text-2xl text-center pt-8 md:pt-12 lg:pt-20">
          Related Articles
        </h3>

        <BlogDetailedCarousel data={data} />
      </div>
    </div>
  );
};
